import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

const EVT = "prat-open-section";

export const openSection = (id) => {
  window.dispatchEvent(new CustomEvent(EVT, { detail: id }));
  setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
};

// Bloc repliable du tableau de bord : fermé par défaut, ouvert au clic (ou via openSection / ancre #id).
export const DashSection = ({ id, eyebrow, title, subtitle, badge, testid, children }) => {
  const [open, setOpen] = useState(() => window.location.hash === `#${id}`);
  useEffect(() => {
    const onEvt = (e) => { if (e.detail === id) setOpen(true); };
    const onHash = () => { if (window.location.hash === `#${id}`) setOpen(true); };
    window.addEventListener(EVT, onEvt); window.addEventListener("hashchange", onHash);
    return () => { window.removeEventListener(EVT, onEvt); window.removeEventListener("hashchange", onHash); };
  }, [id]);
  return (
    <section id={id} data-testid={testid} data-open={open} className="mt-6 rounded-3xl border border-[var(--border)] bg-white/70 overflow-hidden">
      <button type="button" onClick={() => setOpen(!open)} aria-expanded={open} aria-controls={`${id}-body`} data-testid={`${testid}-toggle`}
        className="w-full flex items-start justify-between gap-4 text-left p-5 sm:p-6 hover:bg-[var(--sand)]/60 transition-colors">
        <div className="min-w-0">
          {eyebrow && <div className="text-xs uppercase tracking-[0.25em] font-bold text-[var(--gold)]">{eyebrow}</div>}
          <h2 className="font-serif-title text-2xl sm:text-3xl text-[var(--ink)] mt-0.5 flex flex-wrap items-center gap-3">{title}{badge}</h2>
          {subtitle && <p className="text-sm text-[var(--ink-soft)] mt-1.5 leading-relaxed max-w-3xl">{subtitle}</p>}
        </div>
        <span className={`shrink-0 h-10 w-10 rounded-full border border-[var(--border)] bg-white flex items-center justify-center text-[var(--gold)] transition-transform duration-300 ${open ? "rotate-180" : ""}`}><ChevronDown size={18} /></span>
      </button>
      <div id={`${id}-body`} className={open ? "px-5 sm:px-6 pb-6 animate-fade-up" : "hidden"}>{children}</div>
    </section>
  );
};

export const NewBadge = ({ n, testid }) => (n > 0 ? <span className="text-xs font-sans font-bold rounded-full bg-[#B0553B] text-white px-2.5 py-1" data-testid={testid}>{n} nouveau{n > 1 ? "x" : ""}</span> : null);
